import * as angular from 'angular';

import { severityLevels } from '../../common/constants';
import { ComponentDefinition } from '../../models';

class SeveritiesSelectController implements angular.IComponentController {
    isDisabled: boolean;
    levels: string[];
    static $inject = [];

    $onInit() {
        this.levels = severityLevels.map(d => d.value);
    }
}

export const wtSeveritiesSelect: ComponentDefinition = {
    componentId: 'wtSeveritiesSelect',
    controller: SeveritiesSelectController,
    template: require('./severitiesSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<?',
        model: '=',
        propertyName: '<'
    }
};
